import * as React from "react";
import "./described-label.css";
import { Popup } from "semantic-ui-react";

export default function DescribedLabel({ label, desc }: {
    label: string;
    desc: string;
}): JSX.Element {
    return (
        <Popup content={desc} trigger={<span className="describedLabel">{label}</span>}/>
    );
}
